import styles from "./DecorationImage.module.css";

function DecorationImage({ imgSrc, imgAlt }) {
  return (
    <section className={styles.decoration}>
      <img src={imgSrc} alt={imgAlt} />
    </section>
  );
}

export default DecorationImage;
